<template>
  <div v-if="active" class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Section Settings</p>
        <button class="delete" @click="close"></button>
      </header>
      <section class="modal-card-body">
        <div>
          <p class="blurb">Choose the settings of this section:</p>
        </div>
        <div class="field">
          <div class="control control-post-name">
            <label class="label post-name-label">Section Name</label>
            <input class="input" type="text" v-model="postName" :placeholder="this.post.name">
          </div>
        </div>
        <div class="field dual-field">
          <div class="sub-field sub-field-word-limit">
            <div class="is-flex">
              <label class="label word-limit">Word Limit</label>
              <toggle-switch v-model="wordLimitEnabled"></toggle-switch>
            </div>
            <div class="container">
              <input v-if="!wordLimitEnabled" class="input input-word-limit" placeholder="No Limit" :disabled="!wordLimitEnabled">
              <input v-else class="input input-word-limit" type="number" v-model="maxWords">
              <span>Words</span>
            </div>
          </div>
          <div class="sub-field">
            <label class="label permissions">Section Permissions</label>
            <div class="permissions-container">
              <label class="label edit-subtitle">Edit</label>
              <toggle-switch v-model="allowEdit"></toggle-switch>
              <label v-if="allowEdit" class="label delete-subtitle">Delete</label>
              <toggle-switch v-if="allowEdit" v-model="allowDelete"></toggle-switch>
            </div>
          </div>
        </div>
        <div class="field">
          <label class="label label-lock">Make the following attachments uneditable:</label>
          <div class="control carousel-items">
            <label v-for="(attachment,index) in post.attachments" :key="attachment.id" class="radio">
              <input class="lock-checkbox" type="checkbox" v-model="lockAttachments" :value="attachment.id">{{&nbsp;index+1}}
            </label>
          </div>
        </div>
        <div class="field">
          <label class="label">Maximum number of attachments allowed in this section</label>
          <span>1 Min</span>
          <input v-model="maxAttachments" class="slider is-fullwidth is-medium" step="1" min="1" max="12" value="12" type="range">
          <span>12 Max</span>
          <aside>{{this.maxAttachments}}</aside>
        </div>
        <div v-if="errorMessage" class="help has-text-danger is-size-6 has-text-centered">{{ errorMessage }}</div>
      </section>
      <div class="modal-card-foot is-flex">
        <div class="modal-buttons">
          <button class="button is-primary is-uppercase ml-3" @click="updateSettings">{{ $t('Done') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import componentState from '@/mixins/component-state'
import ToggleSwitch from '@/components/Controls/ToggleSwitch'

export default {
  mixins: [componentState],
  props: ['post'],
  components: {
    ToggleSwitch
  },
  data: function () {
    return {
      active: false,
      errorMessage: '',
      postName: '',
      lockAttachments: [],
      maxWords: 0,
      maxAttachments: 0,
      wordLimitEnabled: false,
      allowEdit: true,
      allowDelete: true
    }
  },
  mounted: function () {
    this.getSettingsFromPost()
  },
  watch: {
    active: function (active) {
      active ? this._callback('lockScrolling', false) : this._callback('unlockScrolling', true)
    },
    post: function () {
      this.getSettingsFromPost()
    },
    allowEdit: function () {
      if (!this.allowEdit) {
        this.allowDelete = false
      }
    }
  },
  methods: {
    cancel: function () {
      this.$emit('modalCancel')
      this.close()
    },
    close: function () {
      this.getSettingsFromPost()
      this.active = false
    },
    updateSettings: function () {
      if (!this.wordLimitEnabled) {
        this.maxWords = 0
      }
      const data = {
        id: this.post.id,
        projectid: this.post.projectID,
        name: this.postName,
        wordLimit: parseInt(this.maxWords),
        attachmentLimit: parseInt(this.maxAttachments),
        attachmentsLocked: this.lockAttachments,
        canEdit: this.allowEdit,
        canDelete: this.allowDelete
      }
      const id = this.post.id
      this.$store.dispatch('postUpdateSettings', { id, data }).then(() => {
        this.close()
        this.getSettingsFromPost()
      }, (error) => {
        this.errorMessage = error
      })
    },
    getSettingsFromPost: function () {
      if (this.post) {
        this.lockAttachments = []
        this.post.attachments.forEach(attachment => {
          if (attachment.locked) {
            this.lockAttachments.push(attachment.id)
          }
        })
        this.maxWords = this.post.maxWords
        this.wordLimitEnabled = this.maxWords !== 0

        this.maxAttachments = this.post.maxAttachments
        if (this.post && this.post.postFeatures) {
          this.postName = this.post.postFeatures ? this.post.postFeatures.name : ''
          this.allowEdit = this.post.postFeatures.canEdit
          this.allowDelete = this.post.postFeatures.canDelete
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/utils.scss';
.modal-card {
  text-align: center;
  overflow: hidden;
  .title {
    border-bottom: 1px solid #DCDCDC;
    padding: 1.3rem 0;
    font-weight: normal;
  }
  .close-button {
    font-size: 1.3rem;
    background-color: transparent;
    opacity: 0.75;
    position: absolute;
    right: 1.25rem;
    top: 0.5rem;
    border: none;
  }
  .submit-questions {
    margin-top: 1rem;
  }
  .modal-card-body {
    height: 100%;
    padding: 2rem 3rem;
    .select {
      width: 90%;
      select {
        display: block;
        width: 100%;
        text-overflow: ellipsis;
        height: 40px;
        font-size: 1rem;
      }
    }
  }
  .modal-buttons{
    width: 300px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
  }
  .lock-checkbox {
    margin-right: 0.25rem;
  }
  label {
    text-align: left;
  }
  .input-word-limit {
    max-width: 7rem;
    text-align: left;
    display: flex;
    margin-right: 0.5rem;
  }
  .container {
    display: flex;
    align-items: center;
  }
  .field {
    margin: 1rem;
  }
  .flex-field {
    display: flex;
    .label-lock {
      margin-right: 1rem;
    }
  }
  .dual-field {
    justify-content: space-between;
    display: flex;
    @include mobile {
      flex-direction: column;
    }
  }
  .sub-field-word-limit {
    @include mobile {
      margin-bottom: 1rem;
    }
  }
  .slider {
    margin-top: 0.5rem;
    width: 60%;
    @include mobile {
    width: 50%;
    }
    position: relative;
    top: 5px;
  }
  .modal-card-head {
    padding-left: 0;
    padding-right: 0;
  }
  .modal-card-foot {
    justify-content: center;
  }
  .delete {
    position: absolute;
    right: 2%;
  }
  .delete-subtitle{
    margin: 0 0.5rem;
    display: inline;
  }
  .edit-subtitle {
    margin: 0 0.5rem 0 0;
    display: inline;
  }
  .carousel-items {
    text-align: left;
  }
  span {
    font-size: 1rem;
    color: #373737;
    white-space: normal;
  }
  .word-limit {
    padding-right: 0.5rem;
  }
  .sub-field {
    width: 50%;
  }
  .permissions-container {
    text-align: left;
  }
  .permissions {
    margin-bottom: 1rem;
  }
  .blurb {
    font-weight: 800;
  }
}
</style>
